import { render, staticRenderFns } from "./FadeTransition.vue?vue&type=template&id=caa7f298&scoped=true"
import script from "./FadeTransition.vue?vue&type=script&lang=js"
export * from "./FadeTransition.vue?vue&type=script&lang=js"
import style0 from "./FadeTransition.vue?vue&type=style&index=0&id=caa7f298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa7f298",
  null
  
)

export default component.exports